import React from 'react';
import { Text, Colors } from '@tapresearch/ui/components';
import { Flex, Badge } from '@mantine/core';

export const CurrentUserLabel = ({
  user,
  constants,
}: {
  user: Record<string, any>;
  constants: Record<string, unknown>;
}) => {
  const isAdmin =
    user.organization_membership.is_active &&
    user.organization_membership.role === constants.ORGANIZATION_ROLE_ADMIN;
  return (
    <Flex direction="column">
      {isAdmin && <AdminBadge />}
      <Text isTruncated d="block" maxW="90%" fontWeight="medium">
        {user.first_name} {user.last_name}
      </Text>
      <Text
        isTruncated
        d="block"
        maxW="90%"
        fontSize="xs"
        fontWeight="medium"
        color="whiteAlpha.700"
        mt={2}
      >
        {user.organization.company_name}
      </Text>
    </Flex>
  );
};

const AdminBadge = () => {
  return (
    <Badge
      bg={Colors.gradients.orangeFuschia}
      radius="xs"
      variant="filled"
      h={16}
      px={5}
      sx={{
        fontWeight: 500,
        textTransform: 'none',
        alignSelf: 'flex-start',
        position: 'relative',
        top: '-8px',
      }}
    >
      Admin
    </Badge>
  );
};
